module.exports = __webpack_public_path__ + "img/content7.f4f52cda.png";